import { OffsetDateTime } from "@js-joda/core";
import BloodGlucoseFormContext from "./BloodGlucoseFormContext";
import { MedicationLog, MedicationLogApiDto } from "./Medication";
import QuickCheckReason from "./QuickCheckReason";

export type BloodGlucoseForm = {
  id: string;
  dateTime: OffsetDateTime;
  context: BloodGlucoseFormContext;
  carbsInGrams?: number;
  proteinInGrams?: number;
  mealContents?: string;
  medications?: MedicationLog | null;
  notes?: string;
  reasons?: QuickCheckReason[];
  readingId?: string;
};

export type BloodGlucoseFormApiDto = {
  id: string;
  dateTime: string;
  context: BloodGlucoseFormContext;
  carbsInGrams?: number;
  proteinInGrams?: number;
  mealContents?: string;
  medications?: MedicationLogApiDto | null;
  notes?: string;
  reasons?: QuickCheckReason[];
  readingId?: string;
};

export const toBloodGlucoseForm = (dto: BloodGlucoseFormApiDto): BloodGlucoseForm => ({
  ...dto,
  dateTime: OffsetDateTime.parse(dto.dateTime),
});
